import LectureLessonListResourcePagingResultModel from '../../generated/types/model/resource/LectureLessonListResourcePagingResultModel';

export default class LectureLessonListResourcePagingResultViewModel extends LectureLessonListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
